import { gql } from 'graphql-request'
import { useMutation, UseMutationResult } from '@/proxy/react-query'

import { client } from '@/proxy/client'

export const SELLER_ACCEPT_ORDERS = gql`
  mutation sellerAcceptOrders($orderNumbers: [String]!) {
    acceptOrders(orderNumbers: $orderNumbers) {
      success
      orderNumber
    }
  }
`

export interface AcceptOrdersInput {
  orderNumbers: string[]
  [key: string]: string[]
}

export interface AcceptOrderResult {
  success: boolean
  orderNumber: string
}

export interface AcceptOrdersResponse {
  acceptOrders: AcceptOrderResult[]
}

export const useSellerAcceptOrders = (): UseMutationResult<
  AcceptOrdersResponse,
  Error,
  AcceptOrdersInput
> =>
  useMutation({
    mutationFn: async (
      variables: AcceptOrdersInput
    ): Promise<AcceptOrdersResponse> => {
      const result: unknown = await client.request(
        SELLER_ACCEPT_ORDERS,
        variables
      )

      if (
        typeof result === 'object' &&
        result !== null &&
        'acceptOrders' in result &&
        Array.isArray(result.acceptOrders)
      ) {
        return result as AcceptOrdersResponse
      }

      throw new Error('Invalid response structure from acceptOrders mutation')
    },
  })
